import { Container, Text, Progress } from '@chakra-ui/react';

interface ProgressData {
  processed?: number;
  total?: number;
}

interface BatchProgressData {
  id: string;
  status: string;
  progress?: ProgressData | null;
}

interface CellData {
  row?: {
    original: BatchProgressData;
  };
  original?: BatchProgressData;
}

interface BatchesTableProgressDrawerProps {
  cell: CellData;
}

const BatchesTableProgressDrawer = ({
  cell,
}: BatchesTableProgressDrawerProps) => {
  const original: BatchProgressData = cell?.row?.original ??
    cell?.original ?? {
      id: '',
      status: '',
    };
  const status = original.status;

  return (
    <Container width="full">
      <Text textAlign="center" mb={4}>
        We're working hard behind the scenes... <br />
        {original.progress?.processed && original.progress?.total
          ? `[${original.progress.processed}] of [${original.progress.total}] passes ${
              status === 'updating' ? 'updated' : 'validated'
            }`
          : null}
      </Text>
      <Progress
        value={
          original.progress?.processed && original.progress?.total
            ? (original.progress.processed / original.progress.total) * 100
            : 1
        }
        colorScheme="green"
        borderRadius={4}
      />
    </Container>
  );
};

export default BatchesTableProgressDrawer;
